import { FC } from "react";

export interface AdonisChatCTAInPDPProps {
  variant: "adonis" | "aria";
  onClick: () => void;
  className?: string;
}

import { cn } from "@/lib/utils";

import AdonisCTAAvatar from "./adonis-pdp-cta-avatar.png";
import AriaCTAAvatar from "./aria-pdp-cta-avatar.png";

export const AdonisChatCTAInPDP: FC<AdonisChatCTAInPDPProps> = ({
  variant,
  onClick,
  className = "",
}) => {
  const avatarSrc = variant === "adonis" ? AdonisCTAAvatar : AriaCTAAvatar;
  const buttonText = variant === "adonis" ? "ASK ADONIS" : "ASK ARIA";

  return (
    <button
      onClick={onClick}
      className={cn(
        "h-[50px] w-full max-w-sm",
        "relative flex items-center overflow-visible",
        "pl-[69px] pr-[3px]",
        "justify-between",
        "rounded-[24px] border-[2px] border-solid border-[#DEC19C] bg-white shadow-sm",
        className
      )}
    >
      <img
        className="pointer-events-none absolute bottom-0 left-0"
        src={avatarSrc}
        alt={`${variant} AI treatment advisor avatar`}
      />
      <span className="flex flex-1 items-start font-sans text-body2 text-[#999999]">
        Have a question?
      </span>
      <div className="rounded-full bg-[#BDA280] px-6 py-3 font-sans text-bold3 text-white">
        {buttonText}
      </div>
    </button>
  );
};
